import React from 'react';
import './Inupt.css';
import { Form } from 'react-bootstrap'

export const Input = ({onChange, ...options}) => {
  const updateValue = (event) => onChange(event.target.value);

  return (<Form.Control className="form-control" type="text" {...options} onChange={updateValue} />);
};